export default __webpack_public_path__ + "static/media/logo-v2.4cf66b8c.svg";